export const MENTION_SUGGESTIONS_AVATAR_SIZE = 28;

export const MENTION_SUGGESTIONS_MIN_WIDTH = 320;

export const MENTION_SUGGESTIONS_MAX_WIDTH = 420;

export const MENTION_SUGGESTIONS_MAX_HEIGHT = 280;

export const MENTION_SUGGESTIONS_EMPTY_LABEL = 'No members match';

export const MENTION_SUGGESTIONS_KEYBOARD_HINTS = [
  { id: 'navigate', key: '↑↓', label: 'Navigate' },
  { id: 'select', key: '↵', label: 'Select' },
  { id: 'dismiss', key: 'Esc', label: 'Dismiss' },
];
